export default "__VITE_ASSET__CCXAL5f4__"